import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AbEquipamentoPac } from "app/abstract/full-pages/equipamento-pac/equipamento-pac.abstract";
import { AppFilter } from "app/models/app-filter.model";
import {
  EquipamentoPacDetail,
  EquipamentoPacEdit,
  EquipamentoPacForm,
  FabricanteEquipamentoPac,
  HistoricoSincronismoEquipamentoPac,
  LogOperacaoEquipamentoPac,
  ModeloEquipamentoPac,
  ResultadoCadastroEquipamentoPac,
  ResultadoTesteConexao
} from "app/pages/full-pages/equipamento-pac/equipamento-pac.models";

@Injectable({ providedIn: 'root' })
export class EquipamentoPacService extends AbEquipamentoPac {

  public prefixo: string = "api/v1/equipamentos-pac/";

  constructor(http: HttpClient) {
    super(http);
  }

  public criar(form: EquipamentoPacForm): Observable<ResultadoCadastroEquipamentoPac> {
    return this.post(this.prefixo, form);
  }

  public testarConexao(id: number): Observable<ResultadoTesteConexao> {
    return this.post(`${this.prefixo}${id}/connection-tests`, {});
  }

  public listarFabricantes(): Observable<FabricanteEquipamentoPac[]> {
    return this.get(`${this.prefixo}fabricantes`).pipe(
      map((fabricantes: any[]) => (fabricantes || []).map(f => ({
        id: f.id,
        nome: f.name,
        modelos: (f.models || []).map((m: any) => ({ id: m.id, nome: m.name })),
      })))
    );
  }

  public listarModelos(fabricanteId: number): Observable<ModeloEquipamentoPac[]> {
    return this.get(`${this.prefixo}fabricantes/${fabricanteId}/modelos`);
  }

  public listar(filter: AppFilter): Observable<any> {
    return this.get(`${this.prefixo}filter/${filter.encode()}`);
  }

  public buscarPorId(id: number): Observable<EquipamentoPacDetail> {
    return this.get(`${this.prefixo}${id}`);
  }

  public editar(id: number, form: EquipamentoPacEdit): Observable<EquipamentoPacDetail> {
    return this.put(this.prefixo.replace(/\/$/, ''), id, form);
  }

  public alterarStatus(id: number, ativo: boolean): Observable<EquipamentoPacDetail> {
    return this.patch(`${this.prefixo}${id}/status`, { ativo }) as Observable<EquipamentoPacDetail>;
  }

  public excluir(id: number): Observable<any> {
    return this.delete(this.prefixo, id);
  }

  public sincronizar(id: number): Observable<any> {
    return this.post(`${this.prefixo}${id}/synchronization`, {});
  }

  public sincronizarTodos(): Observable<any> {
    return this.post(`${this.prefixo}synchronization`, {});
  }

  public resetarUsuarios(id: number): Observable<any> {
    return this.post(`${this.prefixo}${id}/user-reset`, {});
  }

  public historicoSincronismo(id: number): Observable<HistoricoSincronismoEquipamentoPac> {
    return this.get(`${this.prefixo}${id}/sync-history`);
  }

  public listarLogOperacoes(id: number): Observable<LogOperacaoEquipamentoPac[]> {
    return this.get(`${this.prefixo}${id}/operation-logs`);
  }
}
